import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Navbar } from "@/components/ui";
import { Footer } from "@/components/ui/footer";

const About = lazy(() => import("@/routes/about"));
const List = lazy(() => import("@/routes/list"));
const Single = lazy(() => import("@/routes/single"));
const Stats = lazy(() => import("@/routes/stats"));

export default function Router() {
  return (
    <BrowserRouter>
      <Navbar />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<List />} />
          <Route path="/about" element={<About />} />
          <Route path="/list" element={<List />} />
          <Route path="/game/:gameName" element={<Single />} />
          <Route path="/stats" element={<Stats />} />

          <Route path="*" element={<List />} />
        </Routes>
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
}
